/**
 * @generated SignedSource<<952148f129ae50c3b540f87be5f24041>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PostIdType = "DATABASE_ID" | "ID" | "SLUG" | "URI";
export type StatusUiPermissionEnum = "OTP" | "PUBLIC" | "RESTRICTED" | "TOKEN";
export type ZnglyPostTypeEnum = "Catalog" | "Category" | "CrmList" | "Form" | "FormEntry" | "Hub" | "HubPage" | "MediaItem" | "SiteSettings" | "User" | "Znglist";
export type VerifyPostAccessInput = {
  clientMutationId?: string | null | undefined;
  id?: string | null | undefined;
  idType?: PostIdType | null | undefined;
  postType?: ZnglyPostTypeEnum | null | undefined;
};
export type Utils_VerifyPostAccess_Mutation$variables = {
  input: VerifyPostAccessInput;
};
export type Utils_VerifyPostAccess_Mutation$data = {
  readonly verifyPostAccess: {
    readonly hasAccess: boolean | null | undefined;
    readonly sessionActive: boolean | null | undefined;
    readonly uiPermission: StatusUiPermissionEnum | null | undefined;
  } | null | undefined;
};
export type Utils_VerifyPostAccess_Mutation = {
  response: Utils_VerifyPostAccess_Mutation$data;
  variables: Utils_VerifyPostAccess_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "VerifyPostAccessPayload",
    "kind": "LinkedField",
    "name": "verifyPostAccess",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sessionActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasAccess",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uiPermission",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Utils_VerifyPostAccess_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Utils_VerifyPostAccess_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3b2777dce9509383549e1abaaa4fbb79",
    "id": null,
    "metadata": {},
    "name": "Utils_VerifyPostAccess_Mutation",
    "operationKind": "mutation",
    "text": "mutation Utils_VerifyPostAccess_Mutation(\n  $input: VerifyPostAccessInput!\n) {\n  verifyPostAccess(input: $input) {\n    sessionActive\n    hasAccess\n    uiPermission\n  }\n}\n"
  }
};
})();

(node as any).hash = "c2ef9061746a77baa73d84d0f65d5b24";

export default node;
